import { compose } from 'redux';
import { curry, property } from 'lodash-es';
import { jsonApi } from '../http-request';
import { map, filter, propEq, propFromSelector } from '../utils';
import { selectors as name } from '../name';
import { selectors as organization } from '../organization';

const collection = jsonApi.selectors.collection('items');
const findResource = jsonApi.findResource(collection);

const findResourceAndHydrate = curry((fn, state) =>
  compose(
    jsonApi.utils.hydrate(state),
    findResource(fn)
  )(state)
);

const createFacade = selector => {
  const propFromResource = propFromSelector(selector);

  const nameId = propFromResource('name_id');
  const organizationId = propFromResource('organization_id');
  const user = propFromResource('user');

  return {
    id: propFromResource('id'),
    businessName: propFromResource('business_name'),
    code: propFromResource('code'),
    formType: propFromResource('form_type'),
    kind: propFromResource('kind'),
    identifiers: propFromResource('identifiers'),
    itemDefinitionId: propFromResource('item_definition_id'),
    mainImage: propFromResource('main_image'),
    message: propFromResource('message'),
    moveId: propFromResource('move_id'),
    name: compose(
      name.byId,
      nameId
    ),
    // name_id is a Number, but the entire app expects ids to
    // be strings (due to JSON-API), so coercing to String for app consistency.
    nameId: compose(
      String,
      nameId
    ),
    organization: compose(
      organization.byId,
      organizationId
    ),
    organizationId,
    startDate: propFromResource('start_date'),
    endDate: propFromResource('end_date'),
    state: propFromResource('state'),
    status: propFromResource('status'),
    statusUpdatedAt: propFromResource('status_updated_at'),
    subject: propFromResource('subject'),

    // Used for public share item
    fromAddress: propFromResource('from_address'),
    toAddress: propFromResource('to_address'),
    userFirstName: compose(
      property('first_name'),
      user
    ),
  };
};

export const byId = id =>
  createFacade(findResourceAndHydrate(propEq('id', String(id))));

export const byCode = code =>
  createFacade(findResourceAndHydrate(propEq('attributes.code', code)));

export const allByMoveId = curry((id, state) =>
  compose(
    map(byId),
    map(property('id')),
    // attribute id's are returned from the API as numbers, but
    // resource id's are sent back as strings.
    filter(propEq('attributes.move_id', Number(id))),
    collection
  )(state)
);
